module.exports = __webpack_public_path__ + "bm.55b93e100610638ee99d.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/bm.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/bm.svg
// module chunks = styles